import Splide from '@splidejs/splide';


export function initSplides() {
    initProjectSplides()
    initTeaserSplide()
    initOurStorySplide()
    initProjectInfoSplide()
    initNestedSplide()
    initBenefitsSplide()
    initBenefitsGridSplide()
}


function initProjectSplides() {
    var elms = document.getElementsByClassName('kalmes--project-splide');
    for (var i = 0; i < elms.length; i++) {
        new Splide(elms[i], {
            type: "loop",
            perPage: 1,
            fixedWidth: "67%",
            gap: "1rem",
            speed: 1000,
            autoplay: true,
            breakpoints: {
                992: {
                    fixedWidth: "100%",
                    pagination: false,
                }
            }
        }).mount();
    }
}


function initTeaserSplide() {
    var elms = document.getElementsByClassName('kalmes--teaser-splide');

    for (var i = 0; i < elms.length; i++) {
        const splide = new Splide(elms[i], {
            type: "fade",
            rewind: true,
            speed: 2000,
            autoplay: true,
            interval: 3000,
            pauseOnHover: false,
            fixedHeight: "530px",
            breakpoints: {
                992: {
                    fixedHeight: "400px"
                }
            }
        }).mount();

        splide.on('move', function () {
            const items = document.getElementsByClassName('kalmes--triangle-item');
            for (var i = 0; i < items.length; i++) {
                items[i].classList.remove('active');
            }
            const currentSlide = splide.Components.Controller.getIndex();
            const currentSlideElement = splide.Components.Elements.slides[currentSlide];
            const currentProjectId = currentSlideElement.getAttribute('data-project-id');

            const matchingTriangleItem = document.querySelector(`.kalmes--triangle-item[data-project-id="${currentProjectId}"]`);
            if (matchingTriangleItem) {
                matchingTriangleItem.classList.add('active');
            }
        });
    }
}

function initProjectInfoSplide() {
    var elms = document.getElementsByClassName('kalmes--project-info-splide');

    for (var i = 0; i < elms.length; i++) {
        new Splide(elms[i], {
            type: "loop",
            perPage: 3,
            speed: 1000,
            focus: "center",
            autoplay: false,
            fixedWidth: "49%",
            gap: "1.5rem",
            updateOnMove: true,
            pagination: false,
            drag: false,
            breakpoints: {
                992: {
                    perPage: 1,
                    fixedWidth: "100%",
                    autoplay: false,
                    speed: 2000,
                    rewind: false,
                    focus: 0
                }
            }
        }).mount();
    }
}

function initNestedSplide() {
    var elms = document.getElementsByClassName('kalmes--nested-splide');

    for (var i = 0; i < elms.length; i++) {
        const splide = new Splide(elms[i], {
            type: "fade",
            rewind: true,
            speed: 1000,
            autoplay: false,
            drag: true,
        }).mount();
    }
}

function initOurStorySplide() {
    var elms = document.getElementsByClassName('kalmes--our-story-splide');

    for (var i = 0; i < elms.length; i++) {
        new Splide(elms[i], {
            type: "loop",
            speed: 1000,
            interval: 2000,
            autoplay: true,
            arrows: false
        }).mount();
    }
}

function initBenefitsGridSplide() {
    var elms = document.getElementsByClassName('kalmes--benefits-grid-splide');

    for (var i = 0; i < elms.length; i++) {
        new Splide(elms[i], {
            type: 'loop',
            perPage: 4,
            perMove: 1,
            gap: '1rem',
            arrows: true,
            pagination: false,
            breakpoints: {
                992: {
                    destroy: true
                }
            }
        }).mount();
    }
}

function initBenefitsSplide() {
    var elms = document.getElementsByClassName('kalmes--benefits-splide');

    for (var i = 0; i < elms.length; i++) {
        const splide = new Splide(elms[i], {
            type: "fade",
            rewind: true,
            speed: 2000,
            autoplay: true,
            interval: 3000,
            pauseOnHover: false,
            fixedHeight: "450px",
            breakpoints: {
                992: {
                    fixedHeight: "350px"
                }
            }
        }).mount();

        const container = elms[i];
        splide.on('move', function (newIndex) {
            const items = container.getElementsByClassName('kalmes--triangle-item');
            for (var j = 0; j < items.length; j++) {
                items[j].classList.remove('active');
            }
            const match = container.querySelector('.kalmes--triangle-item[data-slide-index="' + newIndex + '"]');
            if (match) {
                match.classList.add('active');
            }
        });
    }
}